import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AccentButton } from '@lyearn-team/frontend-components';
import c from 'classnames';
import { withTheme } from 'emotion-theming';

import { RoomStatus } from 'components/LiveClass/utils/consts';
import CircleIconButton from '../../components/CircleIconButton';
import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class LiveClassMembersButton extends Component {
  render() {
    const { model } = this.props;
    const { isMobile } = model.store;
    const { roomStatus } = model.store.room;

    if (roomStatus !== RoomStatus.Connected) {
      return null;
    }

    const { totalMembers } = model.store.participants;
    const { className, theme } = this.props;
    const { showDrawer } = model.store.membersDrawer;

    if (isMobile) {
      return (
        <CircleIconButton
          active={false}
          className={s.circleButton}
          icon={{ type: 'usersDark' }}
          onClick={showDrawer}
          isMobile={isMobile}
        />
      );
    }

    return (
      <AccentButton
        className={c(s.button, className)}
        text={`Members (${totalMembers})`}
        icon={{ type: 'users', iconColor: theme.color.accent }}
        onClick={showDrawer}
      />
    );
  }
}

export default LiveClassMembersButton;
